import React from 'react';

import { H1, P } from '../typography';
import { ButtonWrapper, Button } from '../button';

import { Embed } from '~/components/embed';

const About = () => (
  <section id="about">
    <H1>1. About the two dudes in the cantina.</H1>
    <P>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </P>

    <P>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </P>

    <Embed
      width={560}
      height={315}
      source="https://www.youtube.com/embed/v1bLB1HHIfM?rel=0&amp;showinfo=0"
      title="Webflow Office Tour + Interview"
    />

    <ButtonWrapper>
      <Button href={process.env.ITUNES}>Join our newsletter</Button>
    </ButtonWrapper>
  </section>
);

export default About;
